<div class="col align-end pointer" (click)="openChat()">
    <div class="reddot" *ngIf="activeHint === true"></div>
    <div class="row align-center gap-8">
        <img
            src="images/default-agent.png"
            class="aiagent pointer"
            title="Jonny Futureson"
            alt=""
        />
        <rr-icon
            name="chevron-down"
            class="chevron"
            *ngIf="!showAiChat"
        ></rr-icon>
        <rr-icon name="chevron-up" class="chevron" *ngIf="showAiChat"></rr-icon>
    </div>
</div>

<div class="animationhintdialog" *ngIf="showHintAnimation">
    <div class="aichatheader row space-between w100 align-center">
        <div class="row gap-8 align-center">
            <img src="images/default-agent.png" class="aiagent" alt="" />
            <h4 class="name tiny" i18n>JOHNNY</h4>
        </div>
        <div class="row align-center gap-12">
            <rr-icon
                name="close"
                (click)="closeAnimationHint()"
                class="roundicon pointer"
                color="nutral"
            ></rr-icon>
        </div>
    </div>
    <div class="content col w100 gap-8">
        <div
            class="conversation col w100 gap-8"
            *ngFor="let message of aiChatHint"
        >
            <div
                class="answer row gap-8"
                *ngIf="message.answer && message.answer !== ''"
            >
                <div class="answertext" markdown ngPreserveWhitespaces>
                    {{ message.answer }}
                </div>
            </div>
        </div>
        <div class="link" (click)="openChat()">Start Dialogue</div>
    </div>
</div>

<div class="aichat col w100 gap-16" *ngIf="showAiChat">
    <div class="aichatheader row space-between w100 align-center">
        <div class="row gap-8 align-center">
            <img src="images/default-agent.png" class="aiagent" alt="" />
            <div class="col">
                <h4 class="name tiny" i18n>JOHNNY</h4>
                <rr-btn
                    type="Link"
                    size="Small"
                    (click)="resetChat()"
                    class="link"
                    i18n
                    >Reset Chat</rr-btn
                >
            </div>
        </div>
        <div class="row align-center gap-12">
            <rr-icon
                name="close"
                (click)="close()"
                class="roundicon pointer"
                color="nutral"
            ></rr-icon>
        </div>
    </div>

    <div class="content col w100 gap-8" #chatContent>
        <div class="conversation col w100 gap-8" *ngFor="let message of aiChat">
            <span
                class="tiny align-self-end"
                *ngIf="message.question && message.question !== ''"
                >ME</span
            >
            <div
                class="question row gap-8"
                *ngIf="message.question && message.question !== ''"
            >
                <div class="questiontext">
                    {{ message.question }}
                </div>
            </div>
            <span class="tiny" *ngIf="message.answer && message.answer !== ''"
                >JOHNNY</span
            >
            <div
                class="answer row gap-8"
                *ngIf="message.answer && message.answer !== ''"
            >
                <!-- <img src="images/default-agent.png" class="chataiagent" alt="" /> -->
                <div class="answertext" markdown ngPreserveWhitespaces>
                    {{ message.answer }}
                </div>
            </div>
            <div class="suggestions col gap-8 w100">
                <!-- <div
          *ngFor="let suggestion of message.dialogMessage; let index = index"
          class="suggestion row gap-16 pointer align-center"
          (click)="selectSuggestion(suggestion)"
        >
          <div class="roundicon">{{ index + 1 }}.</div>
          <div class="suggestion_content" markdown ngPreserveWhitespaces>
            {{ suggestion.text }}
          </div>
        </div> -->
                <div
                    *ngFor="
                        let suggestion of message.formTransfer;
                        let index = index
                    "
                    class="suggestion row gap-16 pointer align-center"
                    (click)="
                        addSuggestionToFormular(suggestion, message.context_id)
                    "
                >
                    <div class="roundicon">
                        <rr-icon name="arrow-left"></rr-icon>
                    </div>
                    <div
                        class="suggestion_content"
                        markdown
                        ngPreserveWhitespaces
                    >
                        {{ suggestion.text }}
                    </div>
                </div>
                <!-- <div
          *ngFor="let suggestion of message.upload; let index = index"
          class="suggestion row gap-16 pointer align-center"
          (click)="uploadFileToRag()"
        >
          <div class="roundicon">{{ index + 1 }}.</div>
          <div class="suggestion_content" markdown ngPreserveWhitespaces>
            {{ suggestion.text }}
          </div>
        </div> -->
                <div
                    class="row gap-8"
                    *ngIf="
                        message.formTransfer &&
                        message.formTransfer?.length !== 0
                    "
                >
                    <rr-btn
                        type="Secondary"
                        iconStart="refresh"
                        (click)="refreshSuggestions()"
                        >Refresh</rr-btn
                    >
                    <!-- <rr-btn
            type="Secondary"
            iconStart="ai"
            (click)="asnwerForMe(message.formTransfer, message.context_id)"
            >Answer for me</rr-btn
          > -->
                </div>
            </div>
        </div>
    </div>
    <rr-btn
        size="small"
        type="Secondary"
        iconStart="upload"
        (click)="uploadFileToRag()"
        *ngIf="aiChat.length !== 0"
        >Upload Knowledge</rr-btn
    >
    <div class="col gap-8 w100 messagebox">
        <textarea
            type="text"
            class="w100"
            i18n
            placeholder="Your message..."
            [formControl]="chatInput"
            (keyup.enter)="send($event)"
        ></textarea>
        <!-- <input
      type="text"
      class="w100"
      i18n
      placeholder="Your message..."
      [formControl]="chatInput"
      (keyup.enter)="send()"
    /> -->
        <div class="row space-between w100 align-center">
            <div class="row">
                <!-- <rr-icon name="paperclip" color="nutral"></rr-icon> -->
                <rr-icon
                    name="mic"
                    color="nutral"
                    class="pointer"
                    *ngIf="recognitionAllowed === true"
                    (click)="startSpeechRecognition()"
                ></rr-icon>
            </div>
            <rr-btn
                type="Primary"
                size="Small"
                iconStart="send"
                [disabled]="disableInput"
                (click)="send($event)"
                >Send</rr-btn
            >
        </div>
    </div>
</div>
<rr-spinner *ngIf="hideLoading"></rr-spinner>
<!-- <div
  class="initialfocus"
  *ngIf="aiChat.length <= 1 && showAiChat == true"
></div> -->
